import { useSnackbar } from 'baseui/snackbar';
import type { AnnotationInfoT } from '../../annotations/types';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
type PropsT = {
  annotation: AnnotationInfoT;
};
export function useObjectInstantiationHandler({
  annotation
}: PropsT) {
  const dispatch = useDispatch();
  const {
    enqueue
  } = useSnackbar();
  const handleObjectInstantiation = () => {
    dispatch({
      type: SIDE_PANEL_ACTIONS.COPY_ANNOTATION_ID,
      annotationId: annotation.id
    });
    enqueue({
      message: 'Instance ID copied. Use it to label the same object when it reappears.'
    });
  };
  return {
    handleObjectInstantiation
  };
}